import { Card, FormSkeleton, PageHeader, RegionCargando, Skeleton, Stack, TablaSkeleton, type ColumnaSkeleton } from "@/components/ui";

/** Encabezado del histórico · compartido por la página y su skeleton. */
export const ENCABEZADO_HISTORICO = {
  titulo: "Histórico documental",
  descripcion:
    "Acervo documental de las solicitudes de pago · consulta, vista previa, descarga y exportación por lote.",
} as const;

/** Columnas de `HistoricoTable` (sin la de selección, que va aparte) · mismo orden y alineación. */
export const COLUMNAS_HISTORICO_SKELETON: ColumnaSkeleton[] = [
  { w: 1.2 }, // Folio
  { w: 1.1 }, // Fecha solicitud
  { w: 2.4, lineas: 2 }, // Proveedor (razón social + RFC/acreedor)
  { w: 2.4 }, // Archivo
  { w: 1.4 }, // Clasificación
  { w: 0.8, align: "right" }, // Tamaño
  { w: 1.5 }, // Sociedad
  { w: 1, align: "center" }, // Acciones
];

/** Tarjeta de filtros en carga · encabezado, 6 campos (3 por fila) y botón Buscar. */
export function HistoricoFiltrosSkeleton() {
  return (
    <Card padding="lg">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1.5" aria-hidden="true">
          <Skeleton height={16} width={70} />
          <Skeleton height={12} width="60%" />
        </div>
        <FormSkeleton campos={6} columnas={3} etiqueta="Cargando filtros…" />
        <div className="flex justify-end" aria-hidden="true">
          <Skeleton height={36} width={110} />
        </div>
      </div>
    </Card>
  );
}

/** Resultados en carga · la tabla real con su columna de selección. */
export function HistoricoResultadosSkeleton({ filas }: { filas: number }) {
  return (
    <TablaSkeleton
      columnas={COLUMNAS_HISTORICO_SKELETON}
      conCheckbox
      filas={filas}
      minWidth={960}
      verticalSpacing="sm"
      etiqueta="Buscando documentos…"
    />
  );
}

/** Página completa en carga · `pendingComponent` de la ruta (mismo marco que la página). */
export function HistoricoDocumentalSkeleton({ filas }: { filas: number }) {
  return (
    <RegionCargando etiqueta="Cargando histórico documental…" className="w-full px-4 py-6 md:px-6">
      <PageHeader
        title={ENCABEZADO_HISTORICO.titulo}
        description={ENCABEZADO_HISTORICO.descripcion}
        actions={
          <div className="flex items-center gap-2" aria-hidden="true">
            <Skeleton height={36} width={36} />
            <Skeleton height={36} width={36} />
          </div>
        }
      />
      <Stack gap="md">
        <div aria-hidden="true" className="flex flex-col gap-4">
          <HistoricoFiltrosSkeleton />
          <HistoricoResultadosSkeleton filas={filas} />
        </div>
      </Stack>
    </RegionCargando>
  );
}
